import { connect } from 'react-redux';

import { IRootState } from 'src/redux/rootReducer';
import { ContentModal, EmailConfirmationModal, Modal, OkModal, YesNoModal } from 'src/components/Modal';
import modalActions from 'src/redux/modal/actions';
import { MODAL_TYPES } from 'src/appConfig/modal';

const ModalContainer: React.FC<Props> = ({ startClosing, isVisible, modalType, hideModal }) => {
  if (!isVisible) return null;

  return (
    <Modal onModalClosed={hideModal} triggerCloseModal={startClosing}>
      <ModalBody modalType={modalType} />
    </Modal>
  );
};

const ModalBody = ({ modalType }: { modalType: string }) => {
  switch (modalType) {
    case MODAL_TYPES.okModal:
      return <OkModal />;
    case MODAL_TYPES.yesNoModal:
      return <YesNoModal />;
    case MODAL_TYPES.emailConfirmationModal:
      return <EmailConfirmationModal />;
    case MODAL_TYPES.contentModal:
      return <ContentModal />;
    default:
      return <OkModal />;
  }
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IRootState) => ({
  isVisible: state.modal.isVisible,
  modalType: state.modal.type,
  startClosing: state.modal.startClosing,
});

const mapDispatchToProps = {
  hideModal: modalActions.hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
